// extracted by mini-css-extract-plugin
export default {"link":"vM-z","disabled":"wM-z"};